export default __webpack_public_path__ + "static/media/backward.8eb59afc.svg";